<template>
  <div class="todo-item" :class="{'checked': checked}">
    <!-- <div class="todo-checkbox">
      <i class="material-icons todo-checkbox-icon">{{ icon }}</i>
    </div> -->
    <div class="todo-label">Step {{ id }} - {{ label }}</div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import Back from "@/modules/Back";
import DownloadManuscript from "./Actions/DownloadManuscript";
import ViewOnAmazon from "./Actions/ViewOnAmazon";
import TurnInReview from "./Actions/TurnInReview";

export default {
  name: "TodoItem",
  props: ["id", "checked", "label", "action", "assignment"],
  components: {
    "download-manuscript": DownloadManuscript,
    "view-on-amazon": ViewOnAmazon,
    "turn-in-review": TurnInReview
  },
  computed: {
    icon() {
      return this.checked ? "check_box" : "check_box_outline_blank";
    }
  },
  methods: {
    toggle() {
      this.checked = !this.checked;

      if (!this.assignment.todos) {
        this.assignment.todos = {};
      }

      this.assignment.todos[this.id] = this.checked;
      Back.saveAssignment(this.assignment);
    }
  }
};
</script>

<style lang="scss" scoped>
.todo-item {
  height: 29px;
  margin: 0px 0;
  font-size: 13pt;
  line-height: 1.2em;
}
.todo-checkbox {
  float: left;
  width: 26px;
  padding: 4px;
  padding-top: 1px;
  font-size: 16pt;
  color: #7e57c2;
  transition: all 0.2s ease-in-out;
}
.todo-checkbox-icon {
  font-size: 13pt !important;
  color: #777;
}
.todo-label {
  float: left;
  padding: 0px 0 0 3px;
  font-size: 12pt;
  line-height: 1.2em;
  color: #555;
}
.todo-action {
  float: right;
  width: 210px;
}

.checked {
  .todo-checkbox {
  }
  .todo-label {
    color: #999;
    text-decoration: line-through;
  }
  .todo-action {
    opacity: 0.6;
  }
}
</style>

